import request from '@/api/request'

export type DashboardKpis = Record<string, number>

export type DashboardSummary = DashboardKpis

export interface DashboardConsole {
  kpis: DashboardKpis
  kpiTimeZone: string
  basicSystemInformation: Record<string, string>
  serverInformation: Record<string, string>
  recentAdminLoginRows: { ipAddress: string; loginTime: string }[]
}

export function fetchDashboardSummary() {
  return request.get<DashboardSummary>('/api/admin/dashboard/summary')
}

export function fetchDashboardConsole() {
  return request.get<DashboardConsole>('/api/admin/dashboard/console')
}
